import { GET_SUPPLIERS, GET_SUPPLIERS_ERROR, GET_SUPPLIERS_SUCCESS } from './HomeForm.actions'

const homeFormInitialState = {
  error: undefined,
  loading: false,
  suppliers: []
}

/**
 * The homeForm's reducer.
 */
const homeFormReducer = (state = homeFormInitialState, { payload, type }) => {
  switch (type) {
    case GET_SUPPLIERS: {
      return { ...state, loading: true, error: undefined }
    }
    case GET_SUPPLIERS_ERROR: {
      return {
        ...state,
        loading: false,
        error: payload.error
      }
    }
    case GET_SUPPLIERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        suppliers: payload.suppliers
      }
    }
    default: {
      return state
    }
  }
}

export default homeFormReducer
